/**
 * MapContext.ts — MapLibre GL map instance shared via React Context (RESEARCH Pattern 7)
 *
 * MapView provides the map instance after the 'load' event fires.
 * Layer components (TractLayer, EVChargerLayer, POILayerMgr) consume it via useMap().
 */
import { createContext, useContext } from 'react'
import type { Map } from 'maplibre-gl'

export const MapContext = createContext<Map | null>(null)

/** Hook: returns the MapLibre Map instance, or null before the map loads. */
export function useMap(): Map | null {
  return useContext(MapContext)
}
